<template>
  <div class="columns mx-0 my-0">
      <div class="column notify has-text-centered has-background-black has-text-white">
        <p class="notify-text">{{notification}}</p>
      </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { adminUtilHandler } from '../graphql/mutations'
export default {
  data(){
    return{
      notification: null,
    }
  },
  methods: {
    async getNotificationText(){
    const Util = {
        id: 1,
        request_type: 'read_one'
      };
    const utils = await API.graphql({
        query: adminUtilHandler,
        variables: 
        {        
        input: Util,
        }
    });
    this.notification = utils.data.adminUtilHandler.important_update
    }
  },
  mounted(){
    this.getNotificationText();
    }
}
</script>

<style>
.notify{
    height: 38px;
    padding-bottom: 0% !important;
}
.notify-text{
    font-family: 'Roboto', sans-serif;
    font-weight: 100;
    font-size: 10pt;
    color: #d0cfce;
}
</style>